module.exports = __webpack_public_path__ + "static/img/big-1.4bfc1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-1.png
// module id = 432+
// module chunks = 65